import { BaseAddress } from '~/types/Address';

export function getLocale() {
  return navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;
}

export const localeCountryCode = () => {
  const locale = getLocale().toUpperCase(); // This could be either 2 or 5 characters.
  return locale.substring(locale.length - 2); // We need the last 2 characters either way.
};

export const guessUsersCountry = (userAddress: Maybe<BaseAddress>): string => {
  if (userAddress?.country?.iso2) {
    return userAddress.country.iso2;
  } else {
    return localeCountryCode();
  }
};
